import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  IconButton,
  InputAdornment,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { HttpStatusCode } from "axios";
import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import validator from "validator";
import { resetPassword } from "../../../../api/controllers/userController";
import { ButtonCustom } from "../../../../components/button";
import { GlobalSnackBar } from "../../../../components/snackBar";
import { ApplicationContext } from "../../../../context/application_ctx";
import { font } from "../../../../styles/font";
import {  TextFieldMA } from "../../../../styles/styledComponents";
import { theme } from "../../../../styles/theme";
export const ResetPassword = ({ setForgotNavigation,setFpSnack,setError,email }) => {
  const {OTP} = useContext(ApplicationContext)

  const navigate = useNavigate();
  const [password, setPassword] = useState(null);
  const [confirmPassword, setConfirmPassword] = useState(null);
  const [resetSnack, setResetSnack] = useState(false);
  const [visibility, setVisiblity] = useState({
    password: false,
    confirmPassword: false,
  });
  console.log(visibility);

  const handleResetPassword = async() => {
    if (!password) {
      setPassword("");
    }
    if (!confirmPassword) {
      setConfirmPassword("");
    }
    if (password && validator.isStrongPassword(password) && confirmPassword && password === confirmPassword) {
      console.log("password reset api call");
      try {
        let response = await resetPassword({
          email,
          otp: OTP,
          newPassword:password,
        });
        console.log(response, "responseLogin");
        if (response.status === HttpStatusCode.Ok) {
          setError(response.data.message);
          setFpSnack(true);
          setTimeout(() => {
            navigate("/signin");
            setForgotNavigation(0);
          }, 3000);
          
        }
        if (response.status === HttpStatusCode.BadRequest) {
          setError(response.data.message);
          setFpSnack(true);
    
        }
      } catch (error) {
        console.log(error);
      }
     
    }
  };
  return (
    <>
      <Box display="flex" width="100%" justifyContent="center">
        <Box
          display="flex"
          width="100%"
          flexDirection={"column"}
          gap="16px"
          justifyContent="center"
        >
          <TextFieldMA
            required
            error={
              password === null
                ? false
                : !validator.isStrongPassword(password) && password !== ""
                ? true
                : password === ""
                ? true
                : false
            }
            helperText={
              password === null
                ? ""
                : !validator.isStrongPassword(password) && password !== ""
                ? "Password must be strong"
                : password === ""
                ? "Password is required"
                : ""
            }
            onBlur={(e) => setPassword(e.target.value)}
            type={visibility.password ? "text" : "password"}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() =>
                      setVisiblity({
                        ...visibility,
                        password: !visibility.password,
                        visibility,
                      })
                    }
                  >
                    {visibility.password ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            fullWidth
            label="Password"
          />
          <TextFieldMA
          onPaste={(e)=>e.preventDefault()}
            required
            error={
              confirmPassword === null
                ? false
                : password !== confirmPassword
                ? true
                : confirmPassword === ""
                ? true
                : false
            }
            helperText={
              confirmPassword === null
                ? ""
                : password !== confirmPassword && confirmPassword
                ? "Password not matching"
                : confirmPassword === ""
                ? "Password is required"
                : ""
            }
            onBlur={(e) => setConfirmPassword(e.target.value)}
            type={visibility.confirmPassword ? "text" : "password"}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() =>
                      setVisiblity({
                        ...visibility,
                        confirmPassword: !visibility.confirmPassword,
                      })
                    }
                  >
                    {visibility.confirmPassword ? (
                      <VisibilityOff />
                    ) : (
                      <Visibility />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            fullWidth
            label="Confirm Password"
          />
          {/* <ButtonMA
            onClick={handleResetPassword}
            variant="contained"
            fullWidth
            sx={{ borderRadius: "46px" }}
          >
            Reset Password
          </ButtonMA> */}
          <ButtonCustom
            onClick={handleResetPassword}
            fullWidth={true}
            disabled={false}
            borderRadius="42px"
            size="large"
            background={theme.col_2}
            backgroundRipple={theme.col_3}
            focusColor={theme.col_1}
            display="flex"
            alignItems="center"
            justifyContent="center"
            typography={
              <Typography
                fontFamily={font.family.fm_2}
                textTransform={"capitalize"}
                fontSize={font.size.fs_3}
                fontWeight="bold"
                color={theme.col_4}
              >
                RESET PASSWORD
              </Typography>
            }
          />
        </Box>
      </Box>
      <GlobalSnackBar open={resetSnack} title={"Password successfully reset"} close={setResetSnack}/>
    </>
  );
};
